import {PreloadedState} from '@reduxjs/toolkit'
import {RootState} from '../'
import {engine} from './engine'
import {name} from '../../../app.json'

type Settings = {
    persist: boolean | undefined
}

export const settings: Settings = {persist: undefined}

export let storageKey = `${name}-state`

export const setStorageKey = (sessionKey?: string) => {
    storageKey = `${storageKey}${sessionKey ? `-${sessionKey}` : ''}`
}

type Filters = {[key: string]: Filters} | boolean
type SubSlice = Record<string, unknown>

export const sliceFilters = new Map<string, Filters>()

const filterSlice = (slice: SubSlice, filters = Object.fromEntries(sliceFilters)) => {
    const filtered: SubSlice = {}

    for (const [key, value] of Object.entries(slice)) {
        const filter = filters[key]
        if (typeof filter === 'boolean' && filter === true) {
            filtered[key] = value
        } else if (typeof filter === 'object') {
            filtered[key] = filterSlice(value as SubSlice, filter)
        }
    }

    return filtered
}

export const getState = (): PreloadedState<object> | undefined => {
    const states = engine.getItem<Partial<RootState>>(storageKey)
    settings.persist = states[1] ? true : states[0] ? false : undefined
    return Object.assign({}, ...states)
}

export const removeSlice = (sliceName: keyof RootState): void => {
    if (settings.persist === undefined) {
        return
    }

    const state = Object.assign({}, ...engine.getItem<Partial<RootState>>(storageKey))
    if (state) {
        delete state[sliceName]
        engine.setItem<Partial<RootState>>(storageKey, state, settings.persist)
    }
}

export const removeState = (): void => {
    engine.removeItem(storageKey)
}

export const setSlice = (slice: Partial<RootState>): void => {
    if (settings.persist === undefined) {
        return
    }

    const state = {
        ...Object.assign({}, ...engine.getItem<Partial<RootState>>(storageKey)),
        ...filterSlice(slice),
    }
    engine.setItem<Partial<RootState>>(storageKey, state, settings.persist)
}

export const disableStorage = (): void => {
    settings.persist = undefined
    removeState()
}

export const enableStorage = (persist: boolean | undefined): void => {
    settings.persist = persist ?? settings.persist
}
